import { Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { CatalogOperationVue } from "../operations/CatalogOperationVue";
import IOperationService from "../../services/operations/IOperationService";
import i18n from "@/i18n";
import { TemplateModel } from "../../models/templates/TemplateModel";
import { TemplateCreateModel } from "../../models/templates/TemplateCreateModel";
import { TemplateData } from "../../data/templateData";
import { TemplatesStore } from "../../store/modules/templates";
import { container } from "@/inversify.config";

export class FsTemplateDialogVue extends CatalogOperationVue {
  get templatesStore(): TemplatesStore {
    return getModule(TemplatesStore, this.$store);
  }

  /**Создание шаблона или редактирование create/edit */
  @Prop() mode!: string;

  /**Данные по операции из истории операций */
  @Prop() operationData!: any;

  @Prop() requestData!: any;

  /**Детали операции */
  @Prop() operationDetails!: Array<any>;

  /**Существующий шаблон (для изменения) */
  @Prop() templateData!: TemplateData;

  /**Заголовок операции */
  @Prop() operationCaption!: string;

  /**Признак видимости диалога */
  @Prop() value!: boolean;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("dialog", { immediate: true })
  async dialogChanged(val: boolean) {
    if (!val) this.destroyForm();
    else await this.initOperation();
  }

  /**Выбранная вкладка */
  activeHref: string = "templateData";

  /**Признак валидности имени */
  nameIsValid: boolean = true;

  /**Видимость пикера даты */
  datePickerVisibility: boolean = false;

  /**Признак ожидания ответа сервера */
  loading: boolean = false;

  /**Загрузка операции каталога */
  catalogOperationLoading: boolean = false;

  // /**Модель операции */
  // catalogOperation: new CatalogOperationModel()

  // catalogOperationCopy: new Dictionary()

  /**Детали операции */
  operDetails: Array<any> = [];
  /**Копия изменяемого шаблона */
  // editTemplateCopy: new TemplateData()
  // saveTemplateCopy: new TemplateData()

  /**Правила заполнения имени */
  nameRules: Array<Function> = [
    (v: any) => !!v || i18n.t("main.templates.nameNecessarily"),
    (v: any) => (v && v.length <= 50) || i18n.t("main.templates.nameLong"),
    (v: any) =>
      (!!v && v[0].split(" ").length <= 1) || i18n.t("main.templates.nameSpace")
  ];

  get isNewTemplate(): boolean {
    return this.mode !== "TemplateEditService";
  }

  get nameCheck(): (isError: boolean) => void {
    return (isError: boolean) => {
      this.nameIsValid = !isError;
    };
  }

  closeDatePicker() {
    this.datePickerVisibility = false;
  }

  openDatePicker() {
    this.datePickerVisibility = true;
  }

  async afterExecute(): Promise<void> {
    this.destroyForm();
  }

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(this.mode);

    this.OperationModel = (await this.service.init(
      this.mode === "TemplateCreateService" ? this.requestData : this.templateData,
      this.contractsStore.contracts,
      this.templatesStore
    )) as TemplateModel | TemplateCreateModel;

    if (this.OperationModel === null) {
      this.loading = false;
      this.destroyForm();
    }

    if (this.mode === "TemplateCreateService") {
      (this.OperationModel as TemplateModel).setOperationDetails(
        this.operationDetails
      );
      (this.OperationModel as TemplateCreateModel).setOperationId(
        this.operationData
          ? this.operationData.Id
          : this.requestData
          ? this.requestData.operationId
          : 0
      );
    }

    this.loading = false;
  }
}
